import HideCardModal from './HideCardModal';

export default HideCardModal;
